export const LOGO_URL = "https://customer-assets.emergentagent.com/job_120fccec-b59e-477e-94be-f34899fb609e/artifacts/0e1f19j7_Cash%20Park%20Logo-07.jpg";
export const SIGNUP_URL = "https://identity.dojah.io/?widget_id=67d17ca0f55304dcbe1c0bfc";
export const CONTACT_EMAIL = "contact@mycashpark.com";
export const CONTACT_PHONE = "+1 403 8272668";
export const CONTACT_PHONE_TEL = "+14038272668";
export const COMPANY_NAME = "CashPark Inc";
export const COMPANY_TAGLINE = "The best Naira–CAD currency exchange platform";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/blogs", label: "Blogs" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];
